export const NAME = 'subject.name';
export const PATIENT_ID = 'subject';
